import { render, staticRenderFns } from "./ToolbarPreview.vue?vue&type=template&id=c5015c22"
import script from "./ToolbarPreview.vue?vue&type=script&lang=js"
export * from "./ToolbarPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports